import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as TextV2 } from '@alfa-bank/site-text-v2/desktop';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { LinkPid as Link } from '@alfa-bank/site-link/link-pid';
import { Grid } from '@alfa-bank/site-grid-universal';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { Img } from '@alfa-bank/site-img';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import styles from '../styles/default/desktop.css';
import { Component } from '../layouts/default/desktop';
import { renderButton } from '../utils/render-button/default/desktop';
import type { IDefaultDepsDesktop, TDefaultDesktop } from '../models';

export const BenefitsBlockDesktop = createWidget<IDefaultDepsDesktop, TDefaultDesktop>({
    styles,
    TextV2,
    Link,
    Button,
    Grid,
    Block,
    Layout,
    Img,
    renderButton,
    sendEvent,
})(Component);
